import { Stack } from "@mui/material";
import SearchBar from "./SearchBar";
import TimeRangeFilter from "./TimeRangeFilter";
import BrandFilter from "./BrandFilter";
import CategoryPathFilter from "./CategoryPathFilter";
import FilterColumns from "./FilterColumns";
import ExportButton from "./ExportButton";
import ImportButton from "./ImportButton";
import PublishButton from "./PublishButton";
import AdsPublishButton from "./AdsPublishButton";
import AdStateFilter from "./AdStateFilter";
import AutomationSwitch from "./AutomationSwitch";
import FilterChipStack from "./FilterChipStack";
import { useBoundStore } from "useStore";

export default function Toolbar() {
  const selectedCampaign = useBoundStore((state) => state.selectedCampaign);
  const isAdsView = !!selectedCampaign;

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={2}
      flexWrap="wrap"
      sx={{ marginBottom: "10px", width: "100%" }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        sx={{ width: "100%", gap: 2 }}
        gap={2}
        flexWrap="wrap"
      >
        <Stack
          direction="row"
          alignItems="center"
          gap={2}
          flexWrap="wrap"
          sx={{ minHeight: "40px" }}
        >
          <SearchBar />
          <TimeRangeFilter />
          <BrandFilter />
          <CategoryPathFilter />
          <AdStateFilter />
          {!isAdsView && <AutomationSwitch />}
          <FilterColumns />
        </Stack>
        <Stack direction="row" alignItems="center" gap={2}>
          {!isAdsView && <ExportButton />}
          {!isAdsView && <ImportButton />}
          {isAdsView ? <AdsPublishButton /> : <PublishButton />}
        </Stack>
      </Stack>
      <FilterChipStack />
    </Stack>
  );
}
